import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { BecomeOurPartnerComponent } from './become-our-partner/become-our-partner.component'
import { FindAccountingfirmComponent } from './find-accountingfirm/find-accountingfirm.component'
import { FindRecommendPartnerInfomationComponent } from './find-accountingfirm/find-recommend-partner-infomation/find-recommend-partner-infomation.component'

const routes: Routes = [
  {
    path: '',
    redirectTo: 'businessowner',
    pathMatch: 'full',
  },
  {
    path: 'businessowner',
    component: FindAccountingfirmComponent,
  },
  {
    path: 'businessowner/information/:nameUrl',
    component: FindRecommendPartnerInfomationComponent,
  },
  {
    path: 'become-our-partner',
    component: BecomeOurPartnerComponent,
  },
  {
    path: 'accountant',
    redirectTo: 'become-our-partner',
    pathMatch: 'full',
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountingfirmRoutingModule {}
